import { enumInventoryAggregateType } from '@rematter/frontend-lib-api-client';
import { Col, Row, Loading, cn } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';
import {
  LucideBox,
  LucideFolderTree,
  LucideBoxes,
  LucideTag,
} from 'lucide-react';

import {
  $remoteInventoryOutboxEventCounts,
  useInventoryAggregateTypeFilter,
} from '@/audit-log/_state/inventoryEvents.state';
import { useTranslations } from '@/audit-log/i18n/useTranslations';

const aggregateTypeConfig = [
  {
    type: enumInventoryAggregateType.Item,
    labelKey: 'item' as const,
    icon: LucideBox,
    countKey: 'item' as const,
  },
  {
    type: enumInventoryAggregateType.Category,
    labelKey: 'category' as const,
    icon: LucideFolderTree,
    countKey: 'category' as const,
  },
  {
    type: enumInventoryAggregateType.ItemGroup,
    labelKey: 'itemGroup' as const,
    icon: LucideBoxes,
    countKey: 'itemGroup' as const,
  },
  {
    type: enumInventoryAggregateType.InventoryTag,
    labelKey: 'inventoryTag' as const,
    icon: LucideTag,
    countKey: 'inventoryTag' as const,
  },
];

export const InventoryEventsSidebar = () => {
  const t = useTranslations();
  const [selectedType, setSelectedType] = useInventoryAggregateTypeFilter();
  const { data: counts, isLoading } = useAtomValue(
    $remoteInventoryOutboxEventCounts,
  );

  const totalCount = counts
    ? counts.item + counts.category + counts.itemGroup + counts.inventoryTag
    : 0;

  return (
    <Col className="@InventoryEventsSidebar w-[200px] border-r border-neutral/10 p-3">
      <Loading isLoading={isLoading}>
        <Col gap2>
          <button
            onClick={() => setSelectedType(undefined)}
            className={cn(
              'flex items-center justify-between rounded-md px-3 py-2 text-sm transition-colors',
              selectedType === undefined
                ? 'bg-primary/10 text-primary'
                : 'hover:bg-neutral/5',
            )}
          >
            <span>{t.inventoryEventsView.sidebar.all}</span>
            <span className="text-xs text-neutral/50">{totalCount}</span>
          </button>

          {aggregateTypeConfig.map(
            ({ type, labelKey, icon: Icon, countKey }) => (
              <button
                key={type}
                onClick={() => setSelectedType(type)}
                className={cn(
                  'flex items-center justify-between rounded-md px-3 py-2 text-sm transition-colors',
                  selectedType === type
                    ? 'bg-primary/10 text-primary'
                    : 'hover:bg-neutral/5',
                )}
              >
                <Row gap2 yCenter>
                  <Icon size={16} className="text-neutral/60" />
                  <span>
                    {t.inventoryEventsView.sidebar.aggregateTypes[labelKey]}
                  </span>
                </Row>
                <span className="text-xs text-neutral/50">
                  {counts?.[countKey] ?? 0}
                </span>
              </button>
            ),
          )}
        </Col>
      </Loading>
    </Col>
  );
};
